import aur from "../apis/aur";

export const fetchRaces = (raceName) =>
     async dispatch => {
        try {
            console.log(raceName)
            dispatch({type: 'LOADING', payload: true})
            const success = await aur.get(`/race/${raceName}`, {timeout:5000})
            return onSuccess(success, dispatch);
        } catch (error) {
            if(error.message === "timeout of 5000ms exceeded"){
                await fetchRaces(raceName)(dispatch);
            }
            return onError(error, dispatch);
        }
}
function onSuccess(success, dispatch) {
    let clone = JSON.parse(JSON.stringify(success.data))
    dispatch({type: 'LOADING', payload: false})
    clone.participants.forEach((participant)=> {
        participant.position = parseInt(participant.position);
        participant.bib = parseInt(participant.bib);
        participant.category_rank = parseInt(participant.category_rank);
    })
    dispatch({type: 'FETCH_RACES', payload: clone});

    return clone;
}


function onError(error, dispatch) {
    dispatch({type: 'LOADING', payload: false})
    dispatch({type: 'ERROR_GENERATED', error});
    return error;
}
// export const fetchRacesById = (playerId) =>
//     async dispatch => {
//         function onSuccess(success) {
//             let clone = JSON.parse(JSON.stringify(success.data))
//             clone.participants.forEach((participant)=> {
//                 participant.position = parseInt(participant.position);
//                 participant.bib = parseInt(participant.bib);
//                 participant.category_rank = parseInt(participant.category_rank);
//             })
//             dispatch({type: 'FETCH_RACES', payload: clone});
//
//             return clone;
//         }
//
//         function onError(error) {
//             dispatch({type: 'ERROR_GENERATED', error});
//             return error;
//         }
//         try {
//             let success = null;
//             success = await aur.get(`/race/bib/${playerId}`);
//             return onSuccess(success);
//         } catch (error) {
//             return onError(error);
//         }
//
//     }
